
import React from 'react';
import {Link} from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';

const DataLineageTable = ({lineages = [], loading, onMenuOpen, menuAnchorEl, menuRowId, onDeleteClick, onMenuClose}) => (
  <div className="table-responsive">
    <table className="table data-table" data-testid="lineage-list">
      <thead>
        <tr>
          <th>Use case name</th>
          <th>Status</th>
          <th>Created on</th>
          <th>Last modified on</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr><td colSpan="5">Loading...</td></tr>
        ) : (
          lineages.map((l, index) => {
            // Extract ID from multiple possible properties
            const diagramId = l.diagram_id || l.id || l.diagramId || index;
            const status = l.status || 'draft';
            const createdAt = l.created_at ? new Date(l.created_at).toLocaleDateString() : '-';
            const updatedAt = l.updated_at ? new Date(l.updated_at).toLocaleDateString() : '-';

            return (
              <tr key={diagramId} data-testid="lineage-row">
                <td>
                  <Link
                    to={{pathname: `/lineage-library/edit/${diagramId}`, state: {id: diagramId}}}
                    className="lineage-link"
                    onClick={(e) => {
                      e.preventDefault();
                      if (typeof window !== 'undefined' && window.history && window.history.pushState) {
                        window.location.href = `/lineage-library/edit/${diagramId}`;
                      }
                    }}
                  >
                    {l.name}
                  </Link>
                </td>
                <td style={{textTransform: 'capitalize'}}>{status}</td>
                <td>{createdAt}</td>
                <td>{updatedAt}</td>
                <td style={{width: 40, textAlign: 'center'}}>
                  <div>
                    <IconButton onClick={(e) => {
                      e.stopPropagation(); onMenuOpen(e, diagramId);
                    }}>
                      <i className='material-icons'>more_horiz</i>
                    </IconButton>
                    <Menu
                      anchorEl={menuAnchorEl}
                      open={menuRowId === diagramId}
                      onClose={onMenuClose}
                      anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                      transformOrigin={{horizontal: 'right', vertical: 'top'}}
                    >
                      <MenuItem onClick={(e) => {
                        e.preventDefault(); onDeleteClick(diagramId);
                      }}>Delete</MenuItem>
                    </Menu>
                  </div>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  </div>
);

export default DataLineageTable;
